import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "32",
  height: "31",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#fff",
      d: "M16 30.75c-5.39 0-10.312-2.812-13.008-7.5-2.695-4.629-2.695-10.312 0-15C5.688 3.621 10.61.75 16 .75c5.332 0 10.254 2.871 12.95 7.5 2.695 4.688 2.695 10.371 0 15A14.89 14.89 0 0 1 16 30.75M21.684 12l-1.934-1.934-.996.996L16 13.817l-2.754-2.754-.996-.996L10.258 12l.996.996 2.754 2.754-2.754 2.754-.996.996 1.992 1.992.996-.996L16 17.742l2.754 2.754.996.996 1.934-1.992-.997-.996-2.753-2.754 2.753-2.754z"
    }, null, -1)
  ])))
}
export default { render: render }